module.exports = "/_next/static/images/bikeProduto-0a42c2539550770958caf3efa92e00c2.svg";